export default "__VITE_ASSET__h5pej$ZC__"